import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { AssetUnderManagementModel } from '../../Models/Models/Business/AssetUnderManagement/AssetUnderManagementModel';
import { IJsonDate } from '../../System/IJsonDate';
import { ExternalTransferStatus } from '../../Constants/Enums/Transfer/ExternalTransferStatus';
import { ServiceProposition } from '../../Constants/Enums/ServiceProposition';

declare var IS_RUNNING_IN_APP_POOL;

export class AssetUnderManagementClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(hierarchyId: string, asAt: IJsonDate, startDate: IJsonDate, endDate: IJsonDate, status: ExternalTransferStatus, servicePropositions: Array<ServiceProposition>): Promise<AssetUnderManagementModel, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Business/AssetUnderManagement/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { hierarchyId: hierarchyId, asAt: asAt, startDate: startDate, endDate: endDate, status: status, servicePropositions: servicePropositions }

    return AjaxWrapper.get<AssetUnderManagementModel, any>(url, data);
  }
}

